import apiClient from '@/api/apiClient.js';
import { getInstProfesId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    catDepartments: [],
    catProvinces: [],
    catDistricts: [],
    modelForm: {},
    data: {},
    status: '',
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    catDepartments(state) {
      return state.catDepartments;
    },
    catProvinces(state) {
      return state.catProvinces;
    },
    catDistricts(state) {
      return state.catDistricts;
    },
    modelForm(state) {
      return state.modelForm;
    },
    data(state) {
      return state.data;
    },
    status(state) {
      return state.status;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
    insertCatDepartments(state, catDepartments) {
      state.catDepartments = catDepartments;
    },
    insertCatProvinces(state, catProvinces) {
      state.catProvinces = catProvinces;
    },
    insertCatDistricts(state, catDistricts) {
      state.catDistricts = catDistricts;
    },
    insertModelForm(state, modelForm) {
      state.modelForm = modelForm;
    },
    saveData(state, data) {
      state.status = 'success';
      state.data = data;
    },
    saveError(state) {
      state.status = 'error';
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        const res = await apiClient.proProfileASchema();
        const schema = res.data;

        const resCat1 = await apiClient.catMentalCareers();
        const catMentalCareers = resCat1.data.data;

        const resCat2 = await apiClient.catStatusLicenses();
        const catStatusLicenses = resCat2.data.data;

        const resCat3 = await apiClient.catBirthSexes();
        const catBirthSexes = resCat3.data.data;

        const resCat4 = await apiClient.catISO3366_1();
        const catISO3366_1 = resCat4.data.data;

        const resCat5 = await apiClient.catDepartments();
        const catDepartments = resCat5.data.data;

        const resCat6 = await apiClient.catProvinces();
        const catProvinces = resCat6.data.data;

        const resCat7 = await apiClient.catDistricts();
        const catDistricts = resCat7.data.data;

        schema.schemaForm.group1.schema.mental_careers_mental_careers_id.items = catMentalCareers;
        schema.schemaForm.group1.schema.status_licenses_status_licenses_id.items =
          catStatusLicenses;
        schema.schemaForm.group2.schema.birth_sexes_birth_sexes_id.items = catBirthSexes;
        schema.schemaForm.group2.schema.users_residence_iso3366.items = catISO3366_1;
        schema.schemaForm.group2.schema.users_residence_department.items = catDepartments;
        schema.schemaForm.group2.schema.users_residence_province.items = catProvinces;
        schema.schemaForm.group2.schema.users_residence_district.items = catDistricts;
        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadCatDepartments({ commit }) {
      try {
        const res = await apiClient.catDepartments();
        const catDepartments = res.data.data;
        commit('insertCatDepartments', catDepartments);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadCatProvinces({ commit }) {
      try {
        const res = await apiClient.catProvinces();
        const catProvinces = res.data.data;
        commit('insertCatProvinces', catProvinces);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadCatDistricts({ commit }) {
      try {
        const res = await apiClient.catDistricts();
        const catDistricts = res.data.data;
        commit('insertCatDistricts', catDistricts);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadModelForm({ commit }, payload) {
      try {
        const id = getInstProfesId();

        let model = {};
        if (payload === undefined) {
          model.usersPin = false;
        } else {
          const usersPin = payload.usersPin;
          model.usersPin = usersPin;
        }

        const res = await apiClient.modelProProfileA(id, model);
        const modelForm = res.data.data;
        modelForm.group2.users_residence_iso3366 = 'PE';
        commit('insertModelForm', modelForm);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async save({ commit }, model) {
      try {
        const id = getInstProfesId();
        const res = await apiClient.updateProProfileA(id, model);
        let data = {};
        data.statusText = res.statusText;
        commit('saveData', data);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error guardando');
        commit('saveError');
        throw error;
      }
    },
  },
};
